import { render, staticRenderFns } from "./table.agreements.vue?vue&type=template&id=d5645872&scoped=true&"
import script from "./table.agreements.vue?vue&type=script&lang=js&"
export * from "./table.agreements.vue?vue&type=script&lang=js&"
import style0 from "./table.agreements.vue?vue&type=style&index=0&id=d5645872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5645872",
  null
  
)

export default component.exports